import RavenUtils from './raven';

let config;
let key;

// Initiallize Sentry.io client
// eslint-disable-next-line no-underscore-dangle
if (typeof window !== 'undefined' && window.__NEXT_DATA__) {
  const { client, env } = window.__NEXT_DATA__.props.pageProps.initialProps.config; // eslint-disable-line no-underscore-dangle
  key = client.sentryPublicKey;
  config = {
    version: env.version,
    environment: env.environment,
    appEnvironment: env.appEnvironment,
    hostname: env.hostname,
    domain: env.domain,
  };
} else {
  const env = require('../../server/config/index'); // eslint-disable-line global-require
  key = env.sentryPublicKey;

  config = {
    version: env.version,
    environment: env.environment,
    appEnvironment: env.appEnvironment,
    hostname: env.hostname,
  };
}

export default function reportErrorToSentry(err, options = {}) {
  try {
    RavenUtils.reportError(err, key, config, options);
  } catch (error) {
    // Catch raven reporting errors
    // TODO: fix "can not find module raven" error on server side
    // eslint-disable-next-line no-console
    console.warn(error);
  }
}



// WEBPACK FOOTER //
// ./app/utils/reportErrorToSentry.js